import { render, staticRenderFns } from "./OrderPlacedModal.vue?vue&type=template&id=a8fe65be&scoped=true&lang=pug"
import script from "./OrderPlacedModal.vue?vue&type=script&lang=js"
export * from "./OrderPlacedModal.vue?vue&type=script&lang=js"
import style0 from "./OrderPlacedModal.vue?vue&type=style&index=0&id=a8fe65be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fe65be",
  null
  
)

export default component.exports